/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize EducationalMaterial Categories View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './educationalMaterialCategoriesView';

export const mapStateToPropsEducationalMaterialCategories = mapStateToProps;
export const mapDispatchToPropsEducationalMaterialCategories =
  mapDispatchToProps;

export default connect(
  mapStateToPropsEducationalMaterialCategories,
  mapDispatchToPropsEducationalMaterialCategories
)(View);
